import React from 'react';

import { ProductsCatalogProvider } from './Provider';
import { Header, Config } from './components';

/**
 * @param {Object} props
 * @param {"exchanges" | "purchases"} props.entity
 */
export default function ProductsCatalog({ entity }) {
  if (!entity) {
    throw new Error('Props "entity" is required for ProductsCatalog');
  }
  if (entity !== 'exchanges' && entity !== 'purchases') {
    throw new Error(
      'Props "entity" must be either "exchanges" or "purchases" in ProductsCatalog'
    );
  }

  return (
    <ProductsCatalogProvider entity={entity}>
      <Header />
      <Config />
    </ProductsCatalogProvider>
  );
}
